import { Tags } from './tags';

export { Tags };
